// utils/dynamicMedia.js

/**
 * Generates the Dynamic Media URL for a given asset code.
 * Automatically switches between production and other environments.
 *
 * @param {string} code - The asset code to generate the URL for.
 * @returns {string} Full URL to the Dynamic Media asset.
 */

class Constants {
  public static readonly ENVIRONMENT_NAME = Constants.getEnvironmentName() ?? 'perf';

  private static getEnvironmentName(): string | null {
    const envMetaTag = document.querySelector('meta[name="envType"]');
    return envMetaTag?.getAttribute('content') &&
      !(
        envMetaTag?.getAttribute('content') === 'test' ||
        envMetaTag?.getAttribute('content') === 'dev'
      )
      ? envMetaTag?.getAttribute('content')
      : 'stage';
  }
}

/**
 * Build the Dynamic Media path for a given asset code.
 *
 * @param code - The asset code or filename without extension
 * @returns The full Dynamic Media URL
 */
export function getDynamicMediaPath(code: string): string {
  if (!code) return '';

  return Constants.ENVIRONMENT_NAME === 'prod'
    ? `https://assets.msccruises.com/is/image/msccruises/${code}`
    : `https://${Constants.ENVIRONMENT_NAME}-assets.msccruises.com/is/image/msccruises${Constants.ENVIRONMENT_NAME}/${code}`;
}

/**
 * Extracts the filename without extension from a DAM path.
 *
 * @param damPath - Full DAM asset path (e.g. "/content/dam/.../msc13024821.jpg")
 * @returns Filename without extension (e.g. "msc13024821")
 */
export function getFileNameWithoutExtension(damPath: string): string {
  if (!damPath) return '';
  const fileName = damPath.split('/').pop() ?? '';
  return fileName.includes('.') ? fileName.substring(0, fileName.lastIndexOf('.')) : fileName;
}
